import React, { useRef } from "react";
import { LeftOutlined, RightOutlined, StarOutlined } from "@ant-design/icons";
import "./HeaderCarousel.scss"
import { Button, Card } from "antd";

interface DishAndDetails {
  dish:any,index:number,itemClick?:any
}


const DishAndDetails = ({dish,index,itemClick}:DishAndDetails) => {
  const scrollRef = useRef<HTMLDivElement>(null); // specify the type here

  const scrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({ left: 300, behavior: "smooth" });
  };

  return (
   

      
        
          <div key={index} 
          >
           <Card
      style={{
        width: 290,
        height: 196,
        padding: 0,
        backgroundImage: "url('/Home/newBg.svg')", // your background SVG
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: 16,
        display: "flex",
        justifyContent: "start",
        alignItems: "flex-end",
      }}
      onClick={itemClick}
      bodyStyle={{ padding: 0 }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        
        <p style={{ marginTop: 8, color: "#fff", fontSize: 16, fontWeight: 700, marginLeft:"20px" }}>
          New to FoodLuv
        </p>
      </div>
    </Card>
    <div style={{ display: "flex", flexDirection: "column", alignItems: "start", gap: 8, marginTop:"10px" }}>
        {/* Top Main Text */}
        <p
          style={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 600,
            fontSize: 16,
            lineHeight: "100%",
            letterSpacing: "0%",
            margin: 0,
            verticalAlign: "middle",
          }}
        >
          Main Heading
        </p>

        {/* Middle row with star icon and text */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {/* Star icon with green background */}
          <div
            style={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              backgroundColor: "green",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <img
              src="/star-white.svg"
              alt="star"
              style={{ width: 14, height: 14 }}
            /> */}
            <StarOutlined style={{ color:"white" }} />
          </div>

          {/* Text beside star */}
          <span
            style={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,
              fontSize: 14,
              lineHeight: "100%",
              letterSpacing: "0%",
              verticalAlign: "middle",
              opacity: 0.7,
            }}
          >
            Rating Info
          </span>
        </div>

        {/* Bottom text */}
        <p
          style={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 500,
            fontSize: 12,
            lineHeight: "100%",
            letterSpacing: "0%",
            margin: 0,
            verticalAlign: "middle",
            opacity: 0.5,
          }}
        >
          Additional Details
        </p>
      </div>
          </div>
       
     
  );
};

export default DishAndDetails;
